<template>
  <field-group
    inline
    :label="label"
    v-model="currentValue"
    typeInput="v-select"
    :items="fonts"
  >
  </field-group>
</template>

<script>
import { API_SYMBOL } from '@/src/service/api'

export default {
  components: {},
  props: {
    value: {},
    label: String,
  },
  data: () => ({ fonts: [] }),
  created() {
    API_SYMBOL.getFonts().then((res) => {
      this.fonts = res.data.data || []
    })
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {},
}
</script>

<style scoped></style>
